import styled from "styled-components";

export const Container = styled.div`
  padding: 15px;
  gap: 16px;
  background: #f5f5f5;
  display: flex;
  height: calc(100vh - 64px);
  flex-direction: column;
  width: 100%;
`;

export const ContainerButton = styled.div`
  width: 100%;
  margin-bottom: 24px;
  button {
    border: solid 1px #000000;
    border-radius: 18px;
    height: 36px;
    padding: 0 15px;
    gap: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
`;

export const ScheduledOrderCard = styled.div`
  display: flex;
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  flex-direction: column;
  gap: 16px;
`;

export const ScheduledOrderCardClientName = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ScheduledOrderCardLocationContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ScheduledOrderCardLocation = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScheculedOrderCardTimeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 8px;
`;

export const ScheculedOrderCardTime = styled.div`
  width: fit-content;
  background: #fbefeb;
  padding: 8px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ScheculedOrderCardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
